import Request from '../../../../src/core/gd/data/request'
import {ViewAccess} from "../const/views/view-type-config"
import CustomView from "../../model2/custom-view/custom-view";
import {RequestType} from "../data/types";

export default class ApiCustomViews {

    static updateNew(customViewId:ID, payload:any) {
        return new Request(this, 'PUT', 'custom-view/'+customViewId+'/update', payload);
    }

    static selectViewData(customViewId:ID, fields:string[] = []) {

        const params = {}
        // @ts-ignore
        _.map(fields, field => params[field] = true)

        return new Request(this, 'GET', 'custom-view/{0}/data-only'.f(customViewId), params);
    }

    static selectViewDataByView(view:CustomView, fields:string[] = [], viewParams: any = {}) {

        const params : any = {
            view        : view.toJSON(),
            ...viewParams
        }
        // no add fields

        _.map(fields, (field: string) => {
            params[field] = true
        })


        return new Request(this, 'POST', 'custom-view-structure/data', params);
    }


    create(viewType:number, name:string, params:any, access:ViewAccess, sharedUsers:any, settings:any, templateId?: ID) {
        return new Request(this, 'POST', 'new-view', {
            companyId: gd.companyId,
            type: viewType,
            name: name,
            params: params,
            access: access,
            sharedUsers: sharedUsers,
            settings: settings,
            templateId: templateId
        });
    }

    getSettings(viewId:ID) {
        return new Request(this, 'GET', 'custom-view/'+viewId+'/edit');
    }

    update(viewId:ID, name:string, params:any, access:ViewAccess, sharedUsers:any, sharedViewId?:ID, settings?:any) {
        const payload = {
            name,
            params,
            access,
            sharedUsers,
            sharedViewId,
            settings
        };

        // // update main menu
        // const bm = gd.session.customViews.get(viewId);
        // if (bm) {
        //     bm.name = name;
        // }

        return new Request(this, 'PUT', 'custom-view/'+viewId+'/update', payload);
    }

    share(viewId:ID, shareStatus:any) {
        const params = {
          shareStatus
        };
        return new Request(this, 'PUT', 'custom-view/'+viewId+'/share', params);
    }

    static getViewV2(viewId:ID) {
        return new Request(this, 'GET', 'custom-view/{0}'.f(viewId));
    }

    getView(viewId:ID) {
        return new Request(this, 'GET', 'custom-view/{0}'.f(viewId));
    }

    // // deperecated use selectViewData
    // getDataOnly(viewId:ID, fields = []) {
    //     const params = {}
    //     // @ts-ignore
    //     _.map(fields, field => params[field] = true)
    //
    //     return new Request(this, 'GET', 'custom-view/{0}/data-only'.f(viewId), params);
    // }

    static getDataV2(viewId:ID, params?:any) {
        return new Request(this, 'GET', 'custom-view/'+viewId+'/data', params);
    }

    getData(viewId:ID, params?:any) {
        return new Request(this, 'GET', 'custom-view/'+viewId+'/data', params);
    }


    // MANAGE

    pinToMainMenu(viewId:ID) {
        return this.setIsPinned(viewId, true);
    }

    unpinFromMainMenu(viewId:ID) {
        return this.setIsPinned(viewId, false);
    }

    setIsPinned(viewId:ID, isPinned:boolean) {
        const customView = gd.session.customViews.get(viewId);
        // if (customView) customView.inMenu = isPinned;

        return new Request(this, 'PUT', 'custom-view/'+viewId+'/pin', {
            isPinned: isPinned
        });
    }

    deleteView(viewId:ID) {
        const customView = gd.session.customViews.get(viewId);
        // if (customView) gd.session.customViews.remove(customView);
        if (customView) {
            gd.session.customViews.remove(viewId)
            gd.navigationStructure.removeViewFromDefaultSectionsPage(customView)
        }

        return new Request(this, 'DELETE', 'custom-view/'+viewId+"/delete");
    }
}
